export const TYPE_UNDERGRADUATE = 20
export const TYPE_COLLEGE = 10
export const CAT_UNDERGRADUATE = 3
export const CAT_COLLEGE = 2
export const LIMIT = 20


// WEBPACK FOOTER //
// ./src/pages/Major/constants/index.js